// extracted by mini-css-extract-plugin
var _1 = "IntegrationsImportLogRow-moduleIntegrationsImportLogRow__fhX0R TableComponent-modulerow__xPAo4";
var _2 = "IntegrationsImportLogRow-moduleblocked__d1yhx TableCellText-moduleTableCellText__b5epO";
var _3 = "IntegrationsImportLogRow-moduleheld__sKixT TableCellText-moduleTableCellText__b5epO";
export { _1 as "IntegrationsImportLogRow", _2 as "blocked", _3 as "held" }
